module.exports = {
  message: {
    login: '登录',
    Username: '用户名',
    Password: '密码',
    Captcha: '验证码',
    Language: '语言',
    zh: '中文',
    en: '英文',

    product_description: '产品介绍',
    home: '首页',
    news: '媒体报道',
    cooperation: '商务合作',
    developer: '开发者',
    join_us: '加入我们',
    about_us: '关于我们',

    more: '了解更多',
    AI_identification: 'AI鉴别',
    AI_identification_desc: '包包、潮鞋、名表 随时随地 秒速鉴别',
    AI_classify: 'AI识包',
    AI_classify_desc: '查款式 比价格 买同款',
    AI_degree: 'AI成色判别',
    AI_degree_desc: '包包成色分级标准判断',
    block_chain: '数字指纹区块链',
    block_chain_desc: '包包隐形唯一"身份证"',
    online_store: '电商购物',
    online_store_desc: '100%保真购物 科技护航，放心交易',
    coop: '商务合作',

    contact_us: '联系我们',
    company_name: '图灵深视（北京）科技有限公司',
    address: '地址：北京市海淀区中关村东路18号财智国际大厦C座1603/1605',
    tel: '手机：18519120710（许经理）',
    Email: '邮箱：mingwei.liu@turingsenseai.com',
    Cooperation: '商务合作：刘先生  18201132061',
    copyright: 'Copyright ©2018-2025 图灵深视（北京）科技有限公司 版权所有',
    copyright_code: '备案编号 京ICP备20007977号-1',

    subscribe: '关注我们',
    wechat_official_account: '微信公众号',
    wechat_mini_program: '微信小程序',
    sina_weibo: '官方微博',

    //  商务合作
    banner1: 'AI鉴别',
    module1: '评估解决方案',
    module1_content1: '针对有开发能力的企业提供API接口；',
    module1_content2: '不具备开发能力的企业可提供单次/批量鉴别服务；',
    module1_content3: '鉴别/评估品类可定制、鉴别品牌可定制等。',
    blockchain: '区块链',
    module2: '溯源解决方案',
    module2_content1: 'AI+IoT（物联网）、AI+PoD（远距离证明）技术服务。',
    banner3: '商家入驻',
    module3_content1: '减免鉴别费、佣金、包装费；',
    module3_content2: '平台内外流量支持；',
    module3_content3: '直播带货等。',
    banner4: '商品云仓',
    module4_content1: '商品信息云端存储，千百商家构建二级市场强大互联资源。',

    // 加入我们
    filter: '职位筛选',
    position: '岗位类型',
    location: '工作地点',
    nature: '职位性质',

    // 旗下产品 & 图灵鉴定
    its_produces_1: '旗下产品',
    its_produces_2: '产品：图灵鉴定',
    its_produces_3: '独立、客观、快速、准确的AI全鉴定平台，累计鉴定量超210万。',
    its_produces_3_1: '图灵鉴定由图灵深视科技有限公司开发的独立、客观、快速、准确的AI全鉴定平台，于2018年12月上线。曾用名包小鉴，2021年6月品牌升级更名为图灵鉴定。',
    its_produces_4: '针对奢侈品、潮鞋等商品的鉴定需求，图灵深视自研高准确度神经网络，进行鉴定点识别与鉴定。所采用算法可以精准区分真品赝品的细微区别，同时具有较高可靠性与迅速的计算速度。积累有奢侈品、潮鞋、名表多个品牌的海量数据，涵盖各种不同款式、系列。用户选择品牌、品类，上传鉴定点图片，就可以获取AI鉴定报告。',
    its_produces_5: '相关专利：',
    its_produces_6: '鉴别模型的训练方法、系统及物品鉴别方法、设备用于鉴别模型的训练、鉴别方法、系统、设备及介质。深度学习方法+细粒度分类算法+融合与创新+对抗生成网络（GAN）+非平衡样本学习+集成学习。',
    its_produces_e_1: '服务人群：',
    its_produces_e_2: '1、各类奢侈品潮品转卖平台。',
    its_produces_e_3: '2、鉴定师、资深潮流玩家、奢品店主、奢侈品SA、带货主播等B端商家。',
    its_produces_e_4: '3、资深玩家、普通消费者、海淘用户等C端用户。',
    its_produces_e_5: '行业意义：',
    its_produces_e_6: '人工鉴定面临鉴定品类无法完全覆盖、鉴定耗时长、鉴定人为失误率高、鉴定估价不准确等问题，成为阻碍行业大规模发展的难解之题，图灵鉴定采用AI鉴定+人工辅助的方式，可客观、独立、准确、快速鉴别全品类非标商品并在估色、估价中规范行业标准化。',

    // 裂物
    exchange_01: '产品：裂物',
    exchange_02: '一个只玩正品好物的圈子，全新C2C交易交换平台。',
    exchange_03: '裂物APP，是图灵深视重磅打造的C2C交易交换平台，为不同兴趣圈子的年轻人玩转正品潮流好物提供了一个鉴定、估价、分享以及交易交换的平台。与传统二手电商交易平台不同，裂物APP将以“以物换物”的玩法，打造趣味、便捷的交易交换体验，并为用户提供一站式智能物品管理方案。',
    exchange_04: '在裂物APP社区里，用户可以随时随地分享自己的正品闲置好物。通过TTC（Top Trading Cycle）算法，全平台将自动匹配最适合每一个用户的等价商品，快速交换闲置物品。',
    exchange_05: '裂变-无限新生，欢迎来到裂物',

    // 精英团队
    elite_team_1: '精英团队',
    elite_team_2: '公司管理层和核心研发人员均是行业资深的专业人士，对计算机视觉应用及软件开发有多年的实施和管理经验，公司拥有完全独立的自主知识产权成熟产品。',

    bossDescList_l_1: '唐平中',
    bossDescList_l_2: '清华大学姚班教授，计算经济学研究室主任',
    bossDescList_l_3: '阿里巴巴第二届达摩院青橙奖获得者',
    bossDescList_l_4: '字节跳动&滴滴出行&百度高级技术顾问',
    bossDescList_l_5: 'MIT科技评论 中国35岁以下的35位科技领袖入选者 （TR35',
    bossDescList_l_6: '美国卡耐基梅隆大学（CMU）计算机系博士后 香港科技大学计算机系博士，中国科技大学学士',
    bossDescList_l_7: '斯坦福大学计算机系（2008-2009），哈佛大学计算机系（2010）以及加州大学伯克利分校（2015）访问教授',
    bossDescList_l_8: 'IJCAI-15媒体论文奖，IJCAI-17杰出青年科学家',
    bossDescList_l_9: '中组部青年千人计划，微软研究院铸星计划，阿里巴巴全球创新计划和首届全国计算机优秀教师奖励计划',

    bossDescList_r_1: '许娅伦',
    bossDescList_r_2: '联合创始人、副总裁',
    bossDescList_r_3: '清华大学交叉信息院硕士',
    bossDescList_r_4: '清华大学电子工程系学士',
    bossDescList_r_5: '本科期间任清华大学学生会副主席',

    bossDescList_r_6: '刘曦',
    bossDescList_r_7: '联合创始人、副总裁',
    bossDescList_r_8: '丰富的AI与数据产品经验',
    bossDescList_r_9: '法国顶级工程师学院硕士',
    bossDescList_r_10: '法新社人脸识别项目原负责人',

    leading_team: '领导团队',
    technical_team: '技术团队',

    team_desc_1: '公司拥有一支由高学历、高素质人才组成的技术团队。',
    team_desc_2_1: '团队不光在AI鉴别技术开发上处于行业前端，我们更注重将可视化的结果对用户表达的清楚与准确。',
    team_desc_2_2: '技术团队均来自清华大学和国内知名大学的博士与硕士，在创意营销、程序算法技术、计算机视觉以及奢侈品场景运用方面有深入的研究。',
    team_desc_3: '团队秉承诚信、规范、专业的同时用独特的创意服务取得用户的信誉，竭诚为用户提供优质、高效、快捷的服务体验。',

    // 落地应用
    land_1: '落地应用',
    land_2: '团队陆续研发并落地了包小鉴-AI鉴别小程序（奢侈品箱包、潮鞋、手表、口红秒速远程鉴别）、AI识包（包包百科库）、AI新旧（成色判别仪）、“数字指纹”区块链技术（防调包神器）。 模型训练采用千万级真伪数据、款式数据、新旧数据，已覆盖包、鞋、表、口红四大品类的主流品牌及90%的款式。无论是精确度还是覆盖品类品牌都在快速迭代。',

    // 知识产权信息
    know_1: '知识产权信息',
    know_2_1: '包小鉴目前针对技术成果和界面设计已提出专利保护，包含',
    know_2_2: 'I类知识产权: 发明专利; II类知识产权: 外观设计专利',

    know_l_1: '物品鉴别模型的训练方法、系统及物品鉴别方法、设备；',
    know_l_2: '用于鉴别的模型的训练、鉴别方法、系统、设备及介质；',
    know_l_3: '物品信息记录、流转、鉴别发起及服务方法、终端和系统；',
    know_l_4: '负载分配方法和系统、计算机装置、节点装置及存储介质；',
    know_l_5: '用于手机的奢侈品鉴别交易图形用户界面。',

    know_c_1: '相关应用产品均已获得十余项计算机软件著作权。',
    know_c_2_1: '包小鉴',
    know_c_2_2: '智能鉴别小程序；',
    know_c_3_1: '图灵深视',
    know_c_3_2: '人工智能开放平台；',
    know_c_4: '深视数据平台；',
    know_c_5: 'AI服务管理台；',

    know_r_1_1: '图灵深视',
    know_r_1_2: '人工智能奢侈品鉴别小程序软件[简称：',
    know_r_1_3: ']；',
    know_r_2_1: '图灵深视',
    know_r_2_2: '算法测试后台；',
    know_r_3_1: '包小鉴',
    know_r_3_2: '管理后台；',
    know_r_4_1: '图灵深视',
    know_r_4_2: '包包后台管理系统；',
    know_r_5: '口罩鉴别小程序；',
    know_r_6: '蟹小鉴。',

    // 关于我们
    about_1: '关于我们',
    about_2_1: '图灵深视科技有限公司（以下简称图灵深视）是由姚期智院士领衔的图灵人工智能研究院孵化 的人工智能企业，于2019 年获批 科技型中小企业、人工智能企业，入选“创业南京”、“创业 栖霞”、“南京市高层次人才引进计划”。',
    about_2: '公司成立于2018年，由清华大学姚班师生发起。图灵深视旨在解决全品类非标商品难以标准化的行业问题，打造了独家AI鉴定+识别+估价技术，赋能奢侈品潮品及相关行业发展。目前已获得包含区块链、溯源等在内共计十余项专利。图灵深视旗下产品包含独立、客观、快速、准确的AI全鉴定平台图灵鉴定、交易交换社区裂物及全球奢品潮品鉴定、采购、批发、带货平台图灵云仓。',
    about_3: '图灵深视于2019 年获批科技型中小企业、人工智能企业，入选创业南京、创业栖霞、南京市高层次人才引进计划。目前已获金沙江创投preA轮融资。 致力于打造商品数字化、金融化新生态，以先进的人工智能、区块链技术赋能商品的安全无阻流通和数字智能管理。',
    qywh_1: '企业文化',
    qywh_2: '图灵深视总部基地位于南京紫东国际创意园，办公场地500余平。以为用户提供严谨、专业、品质化解决方案为公司基本发展战略，以包小鉴自身的品质、先进的技术和优质的服务带给用户可信的鉴别与购买体验。',

    // 发展历程
    m_10: '10月',
    m_12: '12月',
    m_04: '4月',
    m_06: '6月',
    m_07: '7月',
    m_08: '8月',
    m_09: '9月',

    y_2018_tit_01: '包小鉴小程序诞生',
    y_2018_desc_01: '首个面向消费者的AI鉴定平台',
    y_2018_tit_02: '公司成立',
    y_2018_desc_02: '孵化于图灵人工智能研究院',
    // 2019
    y_2019_tit_01: '与国检达成战略合作',
    // y_2019_tit_02: '衍生产品“蟹小鉴”诞生',
    // y_2019_desc_02: 'AI鉴别阳澄湖大闸蟹，趣味营销成热门话题',
    y_2019_tit_03: '开放平台上线',
    y_2019_desc_03: '向有开发能力的企业提供API接口，让技术延申',
    y_2019_tit_04: '品类扩充',
    y_2019_desc_04: '新增潮鞋 手表',
    y_2019_tit_05: 'pre-A轮融资',
    y_2019_desc_05: '金沙江创投',
    y_2019_tit_06: '“数字指纹”区块链功能诞生',
    y_2019_desc_06: '数字化包包流通账本',

    // y_2019_tit_07: '覆盖主流奢侈品牌',
    // y_2019_desc_07: '新增CHANEL、DIOR、PRADA、YSL、CELINE等的AI鉴别功能',
    y_2019_tit_08: 'AI识包上线',
    y_2019_desc_08: '包尔摩斯可一键识别包包款式等',
    // y_2019_tit_09: '新增鉴别品牌，准确率优化提升',
    // y_2019_desc_09: '新增GUCCI AI鉴别，LV鉴别准确率突破96%',

    y_2020_tit_01: '闲置奢品回收寄卖商城上线',
    y_2020_tit_02: 'AI化妆品类鉴定上线',
    y_2020_desc_02: '各大品牌陆续覆盖',
    y_2020_tit_03: 'AI新旧功能上线',
    y_2020_desc_03: '开创包包成色客观评判标准',
    y_2020_tit_04: '商城上线',
    y_2020_desc_04: '200余家商户入驻，交易业务启动',
    // y_2020_tit_05: '轻奢AI鉴别上线共覆盖18个包包品牌',
    // y_2020_desc_05: '轻奢包包：COACH、MK、MCM, 轻奢手表：CACIO、TISSOT',
    // y_2020_tit_06: 'AI口罩鉴别工具上线',
    // y_2020_desc_06: '迅速响应社会需求，助力抗击疫情',
    // y_2020_tit_07: '“包墙”功能上线',
    // y_2020_desc_07: '云端包墙，重资产数字化管理',

    y_2021_tit_01: 'C2C交易交换平台裂物APP上线',
    y_2021_tit_02: '获沸点资本数千万A轮融资',
    y_2021_tit_03: '全球奢侈品潮品鉴定、采购、批发、带货平台图灵云仓上线',

    cloud_tit_01: '产品：图灵云仓',
    cloud_desc_01: '全球奢品潮品鉴定、采购、批发、带货平台。',
    cloud_desc_02: '图灵云仓是由图灵深视科技有限公司于2021年4月推出的为二手奢侈品行业商家提供的B2B交易平台。',
    cloud_desc_03: '图灵云仓提供AI智能收货，一键云仓上架，智能估价等功能，为商家提供仓储、鉴定、同行易货并提升动销，为二手奢侈品行业串联上下游打造的交易生态闭环平台。连接了行业内规模较大的头部交易商家、KOL及行业内以技术服务输出为主的科技公司、服务型公司、包展商等。',
    cloud_desc_04: '产品功能',
    cloud_desc_05: '1、在线云仓',
    cloud_desc_06: '图灵云仓将注册商家发布的商品以图灵标准商品信息维度聚合展示，为商家提供购买、求购功能，为商家展示实时价格行情。',
    cloud_desc_07: '2、快速发布',
    cloud_desc_08: '图灵云仓内含品类品牌丰富全面，20W+标准商品信息可供选择发布，AI识图品牌准确度达99%以上，商家可以快速发布商品，提高效率。',
    cloud_desc_09: '3、智能工具箱',
    cloud_desc_10: '除了提供AI鉴定、AI成色判别、AI估价等AI特色服务，图灵云仓还可一键查价、一键发布抖音、一键阿里拍卖、一键发布快手等，是二手商家的智能工具箱。',
    cloud_desc_11: '产品优势',
    cloud_desc_12: '1、海量货源',
    cloud_desc_13: '海量商家入驻，丰富货源；成色新、款式全，爆款好货；商品聚合，货比三家一秒搞定。',
    cloud_desc_14: '2、AI高效',
    cloud_desc_15: 'AI识图 ：购买发布选款 一张图搞定；AI鉴定： 收包无需鉴定师，AI保障；AI成色判别：统一成色标准；AI估价：海量商品数据，实时动态估价。',
    cloud_desc_16: '3、交易保障',
    cloud_desc_17: '公正、客观、快速、准确的方式为每一件货品予以检验，为每一次交易保驾护航。承诺交易假一赔十。',
    cloud_desc_18: '合作机构/平台',
    cloud_desc_19: '国检上海实验室、北京发改委、北京市政务服务管理局、广州市规划和自然管理局、中检深圳、江苏万维、腾讯、凯泰铭、寺库、闪耀市集（solastage）、只二'
  }
}
